/// <reference types="vite/client" />
import PocketBase from 'pocketbase';
import PocketBaseContext from './PocketBaseContext';
import { ReactNode } from 'react';

const pbUrl = import.meta.env.VITE_WHATSAPP_AUTH_URL;
const pb = new PocketBase(pbUrl);

const PocketBaseProvider = ({ children }: { children: ReactNode }) => {
  return (
    <PocketBaseContext.Provider value={pb}>
      {children}
    </PocketBaseContext.Provider>
  );
};

export default PocketBaseProvider;